import { render, staticRenderFns } from "./manageTemplateQuestionsItem.vue?vue&type=template&id=1c2c8a94"
import script from "./manageTemplateQuestionsItem.vue?vue&type=script&lang=js"
export * from "./manageTemplateQuestionsItem.vue?vue&type=script&lang=js"
import style0 from "./manageTemplateQuestionsItem.vue?vue&type=style&index=0&id=1c2c8a94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports